import React from "react"

const Title = () => (
    <span>Processr&trade; Flow</span>
)

export default Title
